@import 'node_modules/@gaiads/telia-react-component-library/build/styles/colors';
@import 'node_modules/@gaiads/telia-react-component-library/build/styles/zindex';
@import '../breakpoints';
@import '../fonts';

$top-bar-height: 38px;
$main-container-height: 72px;
$segment-links-height: 52px;
$language-links-height: 70px;

.navigation {
  position: sticky;
  top: 0;
  z-index: z(sticky);
  border-bottom: solid 1px color(gray300);
  transition: border-bottom 0s ease-in 0.2s;

  &__mobileMenuOpen {
    @include to('sm') {
      border-bottom: solid 1px transparent;
      transition: border-bottom 0s;
    }
  }

  @include from('md') {
    top: -$top-bar-height;
  }

  &_mainContainer {
    height: $main-container-height;
  }

  &_logo {
    &:focus {
      outline-offset: 2px;
      outline: solid 4px color(blue500);
    }
  }

  &_iconMenuItem {
    // TODO: use stronger selector instead of !important
    margin-left: 16px !important;
    cursor: pointer;
    background-color: color(white);

    &:focus {
      outline-offset: 3px;
      outline: solid 4px color(blue500);
    }

    &::-moz-focus-inner {
      border: 0;
    }

    > svg {
      display: block;
    }
  }

  &_userInitials {
    @include helvetica;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    color: color(white);
    background-color: color(purple500);
    font-weight: bold;
    font-size: 12px;
    width: 26px;
    height: 26px;
  }

  &_hamburger {
    cursor: pointer;
    transform: rotate(0deg);
    transition: transform 0.2s ease-in-out;
    height: 23px;
    width: 24px;

    span {
      display: block;
      position: absolute;
      height: 2px;
      width: 22px;
      background: color(black);
      border-radius: 999px;
      opacity: 1;
      left: 1px;
      transform: rotate(0deg);
      transition: 0.2s ease-in-out;

      &:nth-child(1) {
        top: 5px;
      }

      &:nth-child(2),
      &:nth-child(3) {
        top: 11px;
      }

      &:nth-child(4) {
        top: 17px;
      }
    }
  }

  &_hamburger__active {
    border-radius: 50%;

    span {
      top: 12px;

      &:nth-child(1) {
        width: 0;
        left: 50%;
      }

      &:nth-child(2) {
        width: 22px;
        transform: rotate(45deg);
        background-color: color(black);
      }

      &:nth-child(3) {
        width: 22px;
        transform: rotate(-45deg);
        background-color: color(black);
      }

      &:nth-child(4) {
        width: 0;
        left: 50%;
      }
    }
  }

  &_mobileMenuContainer {
    position: sticky;
    top: $main-container-height;
    z-index: z(mask);
  }

  &_segmentLinksContainer {
    border-bottom: solid 1px color(gray300);
  }

  &_segmentLinks {
    height: $segment-links-height;
  }

  &_languageLinks {
    height: $language-links-height;
  }

  &_loggedOutContainer {
    position: sticky;
    top: $main-container-height;
    z-index: z(mask);
  }

  &_loggedInContainer {
    position: sticky;
    top: $main-container-height;
    z-index: z(mask);

    @include to('sm') {
      max-width: 100%;
    }
  }

  &_loggedInDrawerContainer {
    position: absolute;
    width: 260px;
    right: 0;
  }

  &_menuContainer {
    overflow-y: auto;
    max-height: calc(
      100vh -
        (
          #{$main-container-height} + #{$segment-links-height} + #{$language-links-height}
        )
    );

    @include from('md') {
      transition: margin 0.1s ease-out 0.2s, opacity 0.2s ease-out 0.2s;
      overflow: visible;
      max-height: none;
      margin-left: 24px !important;
      opacity: 1;

      &__slideHidden {
        transition: margin 0.2s, opacity 0.2s;
        overflow: hidden;
        opacity: 0;
        margin-left: 20px !important;
      }
    }
  }
}
